module.exports = __webpack_public_path__ + "officialStatic/img/solution-school.4c5f7f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/solution-school.png
// module id = vXEF
// module chunks = 0